export default __webpack_public_path__ + "static/media/parcours_1_senait_viol.dc2e303e.png";